<template>
  <Popover position="bottom start" class="filters-popover">
    <div class="popover__body">
      <Select
        v-model="mapFilters"
        class="v-select--taggable"
        :placeholder="$t('filters.search.placeholder')"
        :options="availableMapFilters"
        label="label"
        autofocus
        multiple
      >
        <template v-slot:no-options>
          {{ $t('filters.search.no-options') }}
        </template>
      </Select>

      <Btn
        v-if="mapFilters.length"
        variant="link"
        class="filters-popover-reset text-bold pdg0 mrgt--"
        @click="clearMapFilters"
      >
        {{ $t('filters.reset') }}
      </Btn>
    </div>

    <div v-if="recentlyUsedMapFilters.length" class="popover__footer">
      <div data-test="recent-filters">
        <div class="text-bold mrgb--">
          {{ $t('filters.recent.title') }}
        </div>

        <ListInline size="tight">
          <li v-for="(filter, index) in recentlyUsedMapFilters" :key="index">
            <Badge
              :disabled="filter.disabled"
              @click="addMapFilterIfNotExists(filter)"
            >
              {{ filter.label }}
            </Badge>
          </li>
        </ListInline>
      </div>
    </div>
  </Popover>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FILTER_TYPES } from '@/store/modules/live';

import Popover from '@/components/ui/Popover';
import Select from '@/components/ui/Select';
import Badge from '@/components/ui/Badge';

export default {
  components: {
    Popover,
    Select,
    Badge,
  },

  computed: {
    ...mapGetters('courses', ['getLines']),

    mapFilters: {
      get() {
        return this.$store.state.live.mapFilters;
      },
      set(value) {
        this.$store.dispatch('live/setMapFilters', value);
      },
    },

    recentlyUsedMapFilters() {
      return this.$store.state.live.recentlyUsedMapFilters.map(mapFilter => {
        return {
          ...mapFilter,
          disabled: this.$store.getters['live/filterExistsFor'](
            'mapFilters',
            mapFilter
          ),
        };
      });
    },

    availableMapFilters() {
      return [
        ...this.userTypeFilters,
        ...this.userLineFilters,
        ...this.planificationGroupFilters,
      ];
    },

    userTypeFilters() {
      return [
        { path: 'type', value: 'bus', label: this.$t('users.types.bus') },
        {
          path: 'type',
          value: 'inspector',
          label: this.$t('users.types.inspector'),
        },
      ];
    },

    userLineFilters() {
      return this.getLines.map(line => ({
        path: 'details.current_course.line',
        value: line,
        label: this.$t('users.line-number', { line }),
      }));
    },

    planificationGroupFilters() {
      if (this.$store.state.planification) {
        const groups = Object.values(this.$store.state.planification.index);
        return groups.map(group => ({
          path: 'username',
          value: group,
          label: group.name,
          type: FILTER_TYPES.PLANIFICATION_GROUP,
        }));
      } else {
        return [];
      }
    },
  },

  mounted() {
    if (!Object.values(this.getLines).length) {
      this.$store.dispatch('courses/getCourses');
    }
  },

  methods: {
    ...mapActions('live', ['clearMapFilters']),

    addMapFilterIfNotExists(mapFilter) {
      // Remove the disabled property for simpler matching process
      delete mapFilter.disabled;

      this.$store.dispatch('live/addMapFilterIfNotExists', mapFilter);
    },
  },
};
</script>

<style lang="scss">
.popover.filters-popover {
  width: 320px;

  font-size: rem(13px);

  > .popover__body,
  > .popover__footer {
    padding: 15px;
  }
}
</style>
